import { Typography } from '@twistopayments/design-system/components/atoms/typography'

import type { ArticleTableComponent } from '@twisto/api-cms'

import { useHighlightedText } from 'homepage/libs/hooks'

import * as styles from './table.styles'

export const Table = ({ table, title, highlighted }: ArticleTableComponent) => {
  const { after, before, highlight } = useHighlightedText(title, highlighted)

  return (
    <section>
      <Typography css={styles.title} fontWeight="heavy" variant="h2">
        {before}
        <span css={styles.highlighted}>{highlight}</span>
        {after}
      </Typography>
      <div
        dangerouslySetInnerHTML={{ __html: table || '' }}
        css={styles.tableWrapper}
      />
    </section>
  )
}
